import {viewport} from './viewport';

export function calculateCover(height, width) {
  var imageAspectRatio = width / height;
  if (imageAspectRatio >= viewport.aspectRatio) {
    var scaleFactor = viewport.height / height;
    var widthCrop = (width * scaleFactor) - viewport.width;
    return {
      heightCrop: 0,
      scaleFactor: scaleFactor,
      widthCrop: widthCrop,
      xOffset: 0 - widthCrop / 2,
      yOffset: 0,
    };
  }
  var scaleFactor = viewport.width / width;
  var uncroppedHeight = (width * scaleFactor) / imageAspectRatio;
  var heightCrop = uncroppedHeight - viewport.height;
  return {
    scaleFactor: scaleFactor,
    heightCrop: heightCrop,
    widthCrop: 0,
    xOffset: 0,
    yOffset: 0 - heightCrop / 2,
  };
}
